import { FormLabel, Grid, Typography } from '@mui/material';
import { ContractFragment } from '../../../generated/graphql';
import { useApp } from '../../../components/app-context';
import { TextCaption } from '../../../components/text-caption';
import { TextBody1 } from '../../../components/text-body-1';

interface ContractTermsPanelProps {
  contract: ContractFragment;
}

export function ContractTermsPanel(props: ContractTermsPanelProps) {
  const { contract } = props;
  const app = useApp();

  return (
    <Grid container columnSpacing={2} sx={{ flexGrow: 1 }}>
      <Grid size={{ xs: 12 }}>
        <TextCaption>Názov zmluvy</TextCaption>
        <TextBody1>{contract.title}</TextBody1>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TextCaption>Dátum podpisu</TextCaption>
        <TextBody1>{app.formatDate(contract.signingDate)}</TextBody1>
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <TextCaption>Dátum začiatku</TextCaption>
        <TextBody1>{app.formatDate(contract.startDate)}</TextBody1>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextCaption>Dátum konca</TextCaption>
        <TextBody1>{app.formatDate(contract.endDate)}</TextBody1>
      </Grid>

      <Grid size={{ xs: 12, sm: 12 }}>
        <TextCaption>Detaily</TextCaption>
      </Grid>
      <Grid size={{ xs: 12, sm: 12 }}>
        <TextBody1>{contract.note}</TextBody1>
      </Grid>
    </Grid>
  );
  //dangerouslySetInnerHTML={{ __html: contract.note.replace(/\n/g, '<br />') }} />
}
